import { useCopyToClipboard } from '@gogame/hooks-ts';
import { useScreenMessage } from '@gogame/screens';

import { loadCreativeCopyUrl } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

export const useCopyFileLink = () => {
  const copyToClipboard = useCopyToClipboard();
  const { showSuccessMessage } = useScreenMessage();
  return async ({ id }) => {
    const { creativeUrl } = await loadCreativeCopyUrl({ id });
    copyToClipboard(creativeUrl);
    showSuccessMessage('Creative URL copied to your clipboard');
  };
};
